<template>
  <div class="list-table">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h2>Companies' Contacts</h2>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Search..."
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                class="elevation-1"
                item-key="name"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item["Company.name"] }}</td>
                  <td>{{ props.item["Company.address"] }}</td>
                  <td>{{ props.item["Contacts.email"] }}</td>
                  <td>{{ props.item["Contacts.phone"] }}</td>
                  <td>{{ props.item["Contacts.fax"] }}</td>
                  <td>{{ props.item["Contacts.website"] }}</td>
                  <td>{{ props.item["Contacts.facebook"] }}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { Items as Contacts } from "@/api/contacts"

export default {
  data() {
    return {
      pagination: {
        sortBy: "name"
      },
      selected: [],
      search: "",
      complex: {
        headers: [
          {
            text: "Company",
            value: "name"
          },
          {
            text: "Address",
            value: "address"
          },
          {
            text: "Email",
            value: "email"
          },
          {
            text: "Phone",
            value: "phone"
          },
          {
            text: "Fax",
            value: "fax"
          },
          {
            text: "Website",
            value: "website"
          },
          {
            text: "Facebook",
            values: "facebook"
          }
        ],
        items: Contacts
      }
    }
  },
  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.items.slice()
    },
    changeSort(column) {
      console.log(column)
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>
